import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router";
import { useSelector } from 'react-redux'
import Header from './components/header/Header';
import HomePageContainer from './pages/HomePageContainer';
// import ShopHomePageContainer from './pages/ShopHomePageContainer';
import MainBanner from './components/main-banner/MainBanner';
import StepTwo from './pages/steps/StepTwo';
import StepThree from './pages/steps/StepThree';
import StepFour from './pages/steps/StepFour';
import StepFive from './pages/steps/StepFive';
import Thanks from './pages/Thanks';
import Error from './pages/Error';
import ErrorFullApp from './pages/ErrorFullApp';
import Signed from './pages/Signed';
// import Note from './pages/Note';
// import DataProtection from './pages/DataProtection';
import Footer from './components/footer/Footer';
// import GoToTop from './components/go-to-top/GoToTop';
import ScrollToTop from './components/scroll-top/ScrollTop';
// import ModalFaq from './components/static-modals/ModalFaq'
// import FaqBtn from './components/faq-btn/FaqBtn';
import TagManager from 'react-gtm-module'
// import Cookies from './components/cookies/Cookies';
import { withOneTabEnforcer } from "react-one-tab-enforcer"

function App(props) {
  let [ load, setLoad ] = useState(false);

  const tagManagerArgs = {
    gtmId: 'GTM-5563PBC'
  }
 
  TagManager.initialize(tagManagerArgs)

  useEffect(() => {
    if ( !load ) {
        setLoad(true)
    }
  }, [ load ])

  let checkCookie = () => {
    if (typeof window !== 'undefined') {
      if (localStorage.getItem('cookie') != null) {
        return false;
      } else {
        return true;
      }
    }
  }

  return (
    <div className="App">
      {/* <div className="ghost" /> */}
      <Router>
        {window.location.pathname != "/signed" &&
          <MainBanner /> 
        }
        <ScrollToTop>
        <Routes>
            <Route path="/" exact element={ <HomePageContainer /> } />
            <Route path="/kalkulacja/:key" element={ <HomePageContainer /> } />
            {/* <Route path="/sklep" component={ ShopHomePageContainer } /> */}
            {/* <RoutesPaths /> */}
            <Route path="/thank-you" element={ <Thanks /> } />
            {/* <Route path="/nota-prawna" component={ Note } /> */}
            <Route path="/signed" element={ <Signed /> } />
            <Route path="/error-sesja" element={ <ErrorFullApp /> } />
            <Route path="/krok/2" exact element={ <StepTwo /> } />
            <Route path="/krok/3" exact element={ <StepThree /> } />
            <Route path="/krok/4" exact element={ <StepFour /> } />
            <Route path="/krok/5" exact element={ <StepFive /> } />
        </Routes>
        </ScrollToTop>
        {/* < GoToTop /> */}
        {/* <FaqBtn /> */}
        {/* <ModalFaq /> */}
        {/* <Cookies cookieText={`Ta strona wykorzystuje techniczne i funkcjonalne pliki cookies lub internetowe analityczne pliki cookies, za Twoją zgodą marketingowe pliki cookies. Więcej na ten temat przeczytasz w <a id='cookies-link' href="/od/?target=polityka-prywatnosci" target="__blank">Polityce prywatności</a>. Wchodząc na stronę wyrażasz na nie zgodę według ustawień Twojej przeglądarki. Możesz je w każdej chwili zmienić, a jeśli tego nie zrobisz przeglądanie strony nastąpi z wykorzystaniem tych plików.`} visible={ checkCookie() } /> */}
        {window.location.pathname != "/signed" &&
          <Footer />
        }
      </Router>
    </div>
  );
}

// export default withOneTabEnforcer({appName: "grenke-calculator", OnlyOneTabComponent: ErrorFullApp})(App)
const exceptionPaths = ["/signed"];
const currentPath = window.location.pathname;
const ExportedApp = exceptionPaths.includes(currentPath)
  ? App // pomijamy enforcer
  : withOneTabEnforcer({
      appName: "grenke-calculator",
      OnlyOneTabComponent: ErrorFullApp
    })(App);

export default ExportedApp;
// export default App;
